export const MuiDateCalendar = {
  styleOverrides: {
    root: {
      '& .MuiPickersDay-root': {
        '&.Mui-selected': {
          backgroundColor: '#004744',
          color: '#ffffff',
        },
      },
    },
  },
}
